/**
 * Operations with
 * Categories tree
 * Teams tree
 */

import Trees from "./Trees";

export default new Trees();
